import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Team from '../sections/team';
import Topics from '../sections/topics';
import VideoIntroVR from '../../images/movies/wmgr_vr_flythrough.mp4';

import { Player } from 'video-react';

import {
    Alignment,
    Button,
    Classes,
    H5,
    Navbar,
    NavbarDivider,
    NavbarGroup,
    NavbarHeading,
    Switch,
} from "@blueprintjs/core";

/*
      <Player>
      <source src={VideoIntroVR} />
    </Player>  
*/
class About extends Component {
  render() {
    return (
       <div>
        <div className="about_intro">
        </div>
        <div className="banner_callout light">
          <div className="banner_callout_text">
          Wellness Matrix Group is a cutting-edge wellness technology organization built on a philosophy of wholistic health and longevity and backed by a commitment to science-based intelligence and utilizing the latest in technology and data science to make a positive impact on global health through personalized wellness solutions.</div>
      </div>



    <div className="banner aging_healthy">
    <div className="gradient-h">
    <div className="container_space about_content" >
          
          <div className="content_text">
          <div className="content_text_title">Intelligent Personalized Wellbeing</div>
           The resources and technology exist today to make a positive impact on quality of life beyond traditional healthcare and wellness organizations, and we represent a bridge to the possibility of the dream of advanced health wellness and longevity delivery not in the future, but today.  
          </div>
          </div>
    </div>
        </div>

        <div className="container_space" >
          <div className="">
           </div>
        </div>

        
        <Team/>

        <div className="banner_callout gray">
          <div className="banner_callout_text">
          Wellness Matrix Group health and wellness topics cover a range of diverse aspects of our wellbeing.  Below are some of the topics we research and aggregate information to benefit our community.
        </div>
      </div>
        <Topics/>
        <div className="banner_callout blue">
          <div className="banner_callout_text">
          WMGR is committed to continually exploring the latest information and expertise on health and wellness around the world while utilizing advances in technology to deliver wholistic health products and services solutions for customers. 
          </div>
      </div>
    </div>
    );
  }
}

export default About;

/*


*/